import { memo, useCallback } from 'react';

import KpiDynamicCell from '../KpiDynamicCell/KpiDynamicCell';

interface Props {
    id: number;
    index: number;
    kpi: any;
    isCustomer: boolean;
    getKpiNote: (index: number) => string | null;
    setKpiNote: (index: number, note: string) => void;
    shouldFocusMe: boolean;
    setShouldFocusCellId: (value: number | null) => void;
    setDirtyCell: (v: any) => void;
    editDisabled: boolean;
}

const KpiNotesCell = (props: Props) => {
    const { kpi, getKpiNote, setKpiNote, setDirtyCell, ...otherProps } = props;

    const setExternalValue = useCallback((value: string) => {
        setKpiNote(kpi.id, value);
    }, [kpi.id, setKpiNote]);

    const getExternalValue = useCallback(() => {
        return getKpiNote(kpi.id) ?? '';
    }, [kpi.id, getKpiNote]);

    const setExternalDirtyCell = useCallback(() => {
        setDirtyCell({ id: kpi.id, m: 0, y: 0 });
    }, [kpi.id, setDirtyCell]);

    const width = '280px';

    return (
        <KpiDynamicCell
            getExternalValue={getExternalValue}
            setExternalValue={setExternalValue}
            setExternalDirtyCell={setExternalDirtyCell}
            textFieldProps={{ style: { width }, multiline: true }}
            inputProps={{ style: { lineHeight: '1.2' } }}
            divStyle={{ width, padding: '10px 14px', marginTop: '0px', lineHeight: '1.2', whiteSpace: 'pre-line' }}
            {...otherProps}
        />
    );
};

export default memo(KpiNotesCell);
